
import { defineComponent, ref, reactive, watch, nextTick, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

import COVERAPP from '@/utils/COVERAPP'
import PicParticles from '@/utils/PicParticles'

export default defineComponent({
    computed: {
        ...mapState(['activityData'])
    },
    props: ['data'],
    setup (props, context) {
        const $store = useStore()
        const _this = getCurrentInstance() as any
        const $route = useRoute()
        const $router = useRouter()
        const COVER = _this.proxy.$common
        let titleParticles: any = null

        const titleEvent = () => {
            titleParticles = new PicParticles({
                container: document.querySelector('.index-wrapper .title'),
                imgUrl: require('../assets/img/index_title.png'),
                pix: 10,
                duration: 2000,
                color: ['#fff']
            })
        }
        
        onBeforeUnmount(() => {
            titleParticles.forceDestroy()
            titleParticles = null
        })

        onMounted(() => {
            titleEvent()
        })    

        return {
            
        }
    }
})
